<template>
    <rkm-area
        no-margin-top
        title="Pré-natal, parto e nascimento"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="6">
                <Item
                    :get-value="() => item.puericultura.gravidezTipo.nome"
                    label="Tipo de gravidez"
                />
            </rkm-col>

            <rkm-col cols="6">
                <Item
                    :get-value="() => item.puericultura.partoTipo.nome"
                    label="Tipo de parto"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-area
                    title="Idade gestacional"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.puericultura.idadeGestacionalSemanas"
                                label="Semana(s)"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.puericultura.idadeGestacionalDias"
                                label="Dia(s)"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Apgar"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="4">
                            <Item
                                :get-value="() => item.puericultura.apgarPrimeiroMinuto"
                                label="1º minuto"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <Item
                                :get-value="() => item.puericultura.apgarQuintoMinuto"
                                label="5º minuto"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <Item
                                :get-value="() => item.puericultura.apgarDecimoMinuto"
                                label="10º minuto"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-area
                    title="Antropometria ao nascer"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="4">
                            <Item
                                :get-value="() => item.puericultura.peso"
                                append-text="kg"
                                label="Peso"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <Item
                                :get-value="() => item.puericultura.comprimento"
                                append-text="cm"
                                label="Comprimento"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <Item
                                :get-value="() => item.puericultura.perimetroCefalico"
                                append-text="cm"
                                label="Perímetro cefálico"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.puericultura.isCriancaAleitamento && item.puericultura.isPrimeiroAtendimento">
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.puericultura.aleitamentoTipo.descricao"
                    label="Tipo de aleitamento"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>